// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1320":"18122f9e","1820":"18122f9e","2086":"90d9dc9d","4036":"31d6cfe0","7170":"be5eb496","7721":"18122f9e","9408":"0d51fcde"}[chunkId] + ".chunk.css";
};